import { FlightingActions } from "./featureFlags.action.types"

export const UpsertFeatureFlags = (payload: Record<string, boolean>) => {
    return {
        type: FlightingActions.UPSERT_FEATURE_FLAG,
        payload: payload
    }
}

